// extracted by mini-css-extract-plugin
module.exports = {"courseLabel":"course-label_courseLabel__1XMaY"};